var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBudget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 58,
    height: 75,
    viewBox: "0 0 58 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "x9asd49q8a",
    d: "M0 0.695L57.713 0.695 57.713 73.282 0 73.282z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-938 -239) translate(938 239) translate(0 .023)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "up8k8ayidb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#x9asd49q8a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F6BE00",
    d: "M47.113 49.266C34.781 68.123 16.595 77.912 6.518 71.131-3.57 64.36-1.748 43.57 10.597 24.712 22.94 5.862 41.117-3.936 51.194 2.845c10.089 6.774 8.267 27.56-4.08 46.421",
    mask: "url(#up8k8ayidb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M47.008 17.914c0 1.874-1.518 3.393-3.39 3.393-1.87 0-3.391-1.519-3.391-3.393 0-1.873 1.52-3.39 3.392-3.39 1.871 0 3.389 1.517 3.389 3.39",
    transform: "translate(-938 -239) translate(938 239)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M47.008 17.914c0 1.874-1.518 3.393-3.39 3.393-1.87 0-3.391-1.519-3.391-3.393 0-1.873 1.52-3.39 3.392-3.39 1.871 0 3.389 1.517 3.389 3.39",
    transform: "translate(-938 -239) translate(938 239)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M35.503 43.445l-.004.004c-1.732 1.739-4.036 2.697-6.49 2.697-3.668 0-6.984-2.208-8.417-5.55h8.01c.652 0 1.183-.53 1.183-1.18 0-.653-.53-1.183-1.182-1.183h-8.664c-.056-.411-.085-.829-.085-1.242 0-.11.002-.217.007-.325h12.285c.65 0 1.18-.53 1.18-1.18 0-.652-.53-1.182-1.18-1.182H20.254c1.17-3.834 4.702-6.47 8.756-6.47 2.454 0 4.76.959 6.537 2.74.304.221 1.033.488 1.635-.11.576-.577.325-1.277.007-1.613-2.18-2.177-5.078-3.376-8.157-3.376-5.312 0-9.983 3.695-11.221 8.829h-.985c-.651 0-1.183.53-1.183 1.181s.532 1.18 1.183 1.18h.67c-.004.119-.008.236-.008.354 0 .399.022.807.066 1.214h-.728c-.651 0-1.183.53-1.183 1.182 0 .651.532 1.18 1.183 1.18h1.23c1.536 4.706 6.007 7.968 10.976 7.968 3.093 0 6-1.209 8.208-3.43.24-.296.527-1.023-.106-1.654-.601-.602-1.302-.352-1.631-.034",
    transform: "translate(-938 -239) translate(938 239)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M28.856 21.113c-8.77 0-15.908 7.135-15.908 15.906 0 8.77 7.138 15.906 15.908 15.906s15.907-7.136 15.907-15.906-7.137-15.906-15.907-15.906m0 34.064c-10.013 0-18.158-8.145-18.158-18.158 0-10.013 8.145-18.158 18.158-18.158 10.012 0 18.157 8.145 18.157 18.158 0 10.013-8.145 18.158-18.157 18.158",
    transform: "translate(-938 -239) translate(938 239)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBudget);
export default __webpack_public_path__ + "static/media/icon_budget.fec57a9b52c7f4f7a9e2ce7bbf609b3b.svg";
export { ForwardRef as ReactComponent };